import { endpoint } from "../../../../views/pages/manage/common/constant"
import { fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod"

export const getRefundDetail = async (refundNumber) => {
    try {
        return await fetchAllPromisedData(`${endpoint.refund.view}/${refundNumber}`)
    }
    catch (err) {
        console.error(err);
    }
}

export const getLogs = async (data) => {
    try {
        const {refundNumber}= data||{}
       const res= await fetchAllPromisedData(`${endpoint.refund.audit}/${refundNumber}`)
            return res
    }
    catch (err) {
        console.error(err);
    }
}

export const getDropdown= async()=>{
    const dropdown = await Promise.all([
        fetchAllPromisedData(endpoint.businessArea.getAllActiveV2),
    ])
    return {
        businessAreas: dropdown[0],
    }
}